import React, { useState } from 'react';
import { Eye, Trash2, Bell, Undo2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';
import { OFFEN } from '../signaturen/SignaturZeile';

const B = 'inline-flex items-center gap-1 h-7 px-2 rounded-md text-[11px] border transition-colors disabled:opacity-50';
const halt = (fn) => (e) => { e.stopPropagation(); fn(); };

const oeffnen = async (id) => {
  try {
    const r = await api.get(`/documents/${id}/download`, { responseType: 'blob' });
    window.open(URL.createObjectURL(r.data), '_blank');
  } catch { toast.error('Dokument konnte nicht geöffnet werden'); }
};

// Direkt bearbeitbare Aktionen je Zeile in der Mandantenansicht
export const ZeilenAktionen = ({ it, onDone }) => {
  const [busy, setBusy] = useState(false);
  const run = async (fn, ok, frage) => {
    if (frage && !window.confirm(frage)) return;
    setBusy(true);
    try { await fn(); toast.success(ok); onDone(); if (it.area === 'signaturen') window.dispatchEvent(new Event('signaturen-geaendert')); } catch (e) { toast.error(e?.response?.data?.detail || 'Aktion fehlgeschlagen'); }
    setBusy(false);
  };
  if (busy) return <Loader2 className="w-3.5 h-3.5 animate-spin text-[#b8893d]" />;
  if (it.area === 'dokumente') return (
    <span className="inline-flex gap-1">
      <button type="button" onClick={halt(() => oeffnen(it.id))} className={`${B} border-[#1B3A5C]/20 text-[#1B3A5C] hover:border-[#b8893d]`} data-testid={`reg-dok-ansehen-${it.id}`}><Eye className="w-3 h-3" />Ansehen</button>
      <button type="button" onClick={halt(() => run(() => api.delete(`/documents/${it.id}`), 'Dokument gelöscht', `„${it.titel}“ endgültig löschen?`))} className={`${B} border-rose-200 text-rose-700 hover:bg-rose-50`} data-testid={`reg-dok-loeschen-${it.id}`}><Trash2 className="w-3 h-3" /></button>
    </span>
  );
  if (it.area === 'signaturen' && OFFEN.includes(it.status)) return (
    <span className="inline-flex gap-1">
      <button type="button" onClick={halt(() => run(() => api.post(`/admin/esign/${it.id}/senden`), 'Erinnerung gesendet'))} className={`${B} border-[#b8893d]/50 text-[#8f6a2b] hover:bg-[#b8893d] hover:text-white`} data-testid={`reg-sig-erinnern-${it.id}`}><Bell className="w-3 h-3" />Erinnern</button>
      <button type="button" onClick={halt(() => run(() => api.patch(`/admin/esign/${it.id}/stornieren`), 'Zurückgezogen', 'Signaturanfrage zurückziehen? Der Link wird ungültig.'))} className={`${B} border-rose-200 text-rose-700 hover:bg-rose-50`} data-testid={`reg-sig-zurueck-${it.id}`}><Undo2 className="w-3 h-3" />Zurückziehen</button>
    </span>
  );
  return null;
};

export default ZeilenAktionen;
